import { Model, ModelJSON } from '../core/model';

/**
 * Snapshot-basierte Undo/Redo-Historie: vor jeder kommittierten Änderung wird der
 * aktuelle Modellzustand gesichert. Bei Camper-Modellgrößen ist das robuster und
 * einfacher als ein Command-Pattern.
 */
export class History {
  private undoStack: ModelJSON[] = [];
  private redoStack: ModelJSON[] = [];

  constructor(private limit = 100) {}

  /** Vor einer Änderung aufrufen — sichert den Zustand VOR der Änderung. */
  push(model: Model): void {
    this.undoStack.push(model.toJSON());
    if (this.undoStack.length > this.limit) this.undoStack.shift();
    this.redoStack.length = 0;
  }

  get canUndo(): boolean {
    return this.undoStack.length > 0;
  }

  get canRedo(): boolean {
    return this.redoStack.length > 0;
  }

  undo(model: Model): boolean {
    const prev = this.undoStack.pop();
    if (!prev) return false;
    this.redoStack.push(model.toJSON());
    applySnapshot(model, prev);
    return true;
  }

  redo(model: Model): boolean {
    const next = this.redoStack.pop();
    if (!next) return false;
    this.undoStack.push(model.toJSON());
    applySnapshot(model, next);
    return true;
  }

  clear(): void {
    this.undoStack.length = 0;
    this.redoStack.length = 0;
  }
}

function applySnapshot(target: Model, json: ModelJSON): void {
  const restored = Model.fromJSON(json);
  target.vertices = restored.vertices;
  target.edges = restored.edges;
  target.faces = restored.faces;
  target.guides = restored.guides;
  target.groups = restored.groups;
  target.nextId = restored.nextId;
}
